import { baseApi } from '@/api/rtk/baseApi';
import { runMutation } from '@/api/rtk/runEndpoint';
import { handleUpdateError } from '@/api/imperative/records';
import '@/api/rtk/mutationsApi';

export const getSignedUrl = async ({ id, name, type, meta_type }, retryCount = 0) => {
  const MAX_RETRIES = 3;
  try {
    const data = await runMutation(baseApi.endpoints.getSignedUrl, {
      name,
      type,
      meta_type,
    });
    return type === 'download_folder' ? data.urls : data?.url;
  } catch (err) {
    const message = typeof err === 'string' ? err : err?.data || err?.message || err?.toString?.();
    const isFetchError =
      message === 'Failed to fetch' || message === 'Load failed' || err?.name === 'TypeError';

    if (isFetchError && retryCount < MAX_RETRIES) {
      console.log(`Retry attempt ${retryCount + 1} of ${MAX_RETRIES} for getting signed URL`);
      await new Promise((resolve) => setTimeout(resolve, 1000 * (retryCount + 1)));
      return getSignedUrl({ id, name, type, meta_type }, retryCount + 1);
    }

    if (type === 'upload') {
      handleUpdateError({ id, error: 'Failed to fetch signed url', context: String(err) });
    }
    return null;
  }
};

export const uploadToS3 = async ({ id, file, signedUrl, skipReportErrorUpdate = false }, retryCount = 0) => {
  const MAX_RETRIES = 3;
  try {
    const response = await fetch(signedUrl, {
      method: 'PUT',
      body: file,
    });

    if (response.ok) {
      console.log('File uploaded successfully');
      return { documentId: id, uploadStatus: true };
    }
    throw new Error(`Failed to upload file: ${response.statusText}`);
  } catch (err) {
    const isFetchError = err.message === 'Failed to fetch' || err.name === 'TypeError';

    if (isFetchError && retryCount < MAX_RETRIES) {
      console.log(`Retry attempt ${retryCount + 1} of ${MAX_RETRIES} for file upload`);
      await new Promise((resolve) => setTimeout(resolve, 1000 * (retryCount + 1)));
      return uploadToS3({ id, file, signedUrl, skipReportErrorUpdate }, retryCount + 1);
    }

    if (!skipReportErrorUpdate) {
      handleUpdateError({ id, error: 'Failed to upload file', context: err.toString() });
    }
    console.log('Error while uploading file: ', err);
    return null;
  }
};
